import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogTitle, IconButton, Box, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const isMobile = () => typeof window !== 'undefined' && window.innerWidth < 600;

const MobileAppModal = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (isMobile() && !sessionStorage.getItem('mobileAppModalShown')) {
      setOpen(true);
      sessionStorage.setItem('mobileAppModalShown', 'true');
    }
  }, []);

  const handleClose = () => setOpen(false);

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: 1 }}>
        <Typography variant="h6" sx={{ fontWeight: 700, fontSize: '1.1rem' }}>
          Get the App!
        </Typography>
        <IconButton onClick={handleClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ textAlign: 'center', pt: 0 }}>
        <Typography sx={{ mb: 2, fontSize: '1rem' }}>
          Download our mobile app for the best experience:
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', gap: 2, mb: 1 }}>
          <a href="#" target="_blank" rel="noopener noreferrer">
            <img
              src={require('../assets/google-play-badge.png')}
              alt="Get it on Google Play"
              style={{ height: 48, width: 'auto', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.10)', transition: 'transform 0.2s', cursor: 'pointer' }}
              onMouseOver={e => (e.currentTarget.style.transform = 'scale(1.05)')}
              onMouseOut={e => (e.currentTarget.style.transform = 'scale(1)')}
            />
          </a>
          <a href="https://apps.apple.com/us/app/receiptsnap-ai/id6753581452" target="_blank" rel="noopener noreferrer">
            <img
              src={require('../assets/app-store-badge.png')}
              alt="Download on the App Store"
              style={{ height: 48, width: 'auto', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.10)', transition: 'transform 0.2s', cursor: 'pointer' }}
              onMouseOver={e => (e.currentTarget.style.transform = 'scale(1.05)')}
              onMouseOut={e => (e.currentTarget.style.transform = 'scale(1)')}
            />
          </a>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default MobileAppModal; 